import type { TFn } from '../core/lexicon';
import { countdown } from '../core/util';
import { Screen, TopBar, CenterNote } from './Layout';
import type { CurrentRound } from '../core/types';

export function votingRight(round: CurrentRound | null): string | undefined {
  return round ? countdown(round.voting_deadline) ?? undefined : undefined;
}

/** "Listen now" — opens the round's curated Spotify playlist (once an admin has
 *  built it). Shown on the voting screens; the wording is per-style via lexicon. */
export function ListenLink({ t, round }: { t: TFn; round: CurrentRound | null }) {
  if (!round?.playlist_url) return null;
  return (
    <a className="listen" href={round.playlist_url} target="_blank" rel="noopener noreferrer">
      ♪ {t('spotify.listen').toUpperCase()}
    </a>
  );
}

export function VotingLoading({ title }: { title: string }) {
  return (
    <Screen>
      <TopBar title={title} />
      <CenterNote>
        <div className="spin">LOADING…</div>
      </CenterNote>
    </Screen>
  );
}

/** Shown when there is no round in VOTING — the task simply isn't open. */
export function VotingClosed({
  t,
  title,
  round,
}: {
  t: TFn;
  title: string;
  round: CurrentRound | null;
}) {
  return (
    <Screen>
      <TopBar title={title} right={votingRight(round)} />
      <CenterNote title={t('state.shut').toUpperCase()}>
        <p>{round ? t('phase.points.name') + ' — ' + t('state.locked') : t('empty.no_round')}</p>
      </CenterNote>
    </Screen>
  );
}
